import { defineMessages } from 'react-intl'

const scope = 'procurify.expense.components.ExpenseLineItemForm'

export default defineMessages({
  needsReimbursementLabel: {
    id: `${scope}.needsReimbursementLabel`,
    defaultMessage: 'Needs reimbursement',
  },
  vendorNameLabel: {
    id: `${scope}.vendorNameLabel`,
    defaultMessage: 'Vendor name',
  },
  vendorNamePlaceholder: {
    id: `${scope}.vendorNamePlaceholder`,
    defaultMessage: 'Vendor name',
  },
  vendorNameRequired: {
    id: `${scope}.vendorNameRequired`,
    defaultMessage: 'Vendor name is required',
  },
  dateLabel: {
    id: `${scope}.dateLabel`,
    defaultMessage: 'Date',
  },
  dateRequired: {
    id: `${scope}.dateRequired`,
    defaultMessage: 'Date is required',
  },
  accountCodeLabel: {
    id: `${scope}.accountCodeLabel`,
    defaultMessage: 'Account code',
  },
  notesLabel: {
    id: `${scope}.notesLabel`,
    defaultMessage: 'Notes',
  },
  notesPlaceholder: {
    id: `${scope}.notesPlaceholder`,
    defaultMessage: 'Notes',
  },
  financialDetailsLabel: {
    id: `${scope}.financialDetailsLabel`,
    defaultMessage: 'Financial details',
  },
  subtotalLabel: {
    id: `${scope}.subtotalLabel`,
    defaultMessage: 'Subtotal',
  },
  taxAmountLabel: {
    id: `${scope}.taxAmountLabel`,
    defaultMessage: 'Tax amount',
  },
  tipsLabel: {
    id: `${scope}.tipsLabel`,
    defaultMessage: 'Tips',
  },
  mileageRateLabel: {
    id: `${scope}.mileageRateLabel`,
    defaultMessage: 'Mileage rate',
  },
  distanceLabel: {
    id: `${scope}.distanceLabel`,
    defaultMessage: 'Distance',
  },
  unitKm: {
    id: `${scope}.unitKm`,
    defaultMessage: 'km',
  },
  unitMi: {
    id: `${scope}.unitMi`,
    defaultMessage: 'mi',
  },
  hourlyRateLabel: {
    id: `${scope}.hourlyRateLabel`,
    defaultMessage: 'Hourly rate',
  },
  hoursOfWorkLabel: {
    id: `${scope}.hoursOfWorkLabel`,
    defaultMessage: 'Hours of work',
  },
  airlineLabel: {
    id: `${scope}.airlineLabel`,
    defaultMessage: 'Airline',
  },
  ticketNumberLabel: {
    id: `${scope}.ticketNumberLabel`,
    defaultMessage: 'Ticket number',
  },
  departureDateLabel: {
    id: `${scope}.departureDateLabel`,
    defaultMessage: 'Departure date',
  },
  arrivalDateLabel: {
    id: `${scope}.arrivalDateLabel`,
    defaultMessage: 'Arrival date',
  },
  totalCostLabel: {
    id: `${scope}.totalCostLabel`,
    defaultMessage: 'Total cost',
  },
  paymentMethodLabel: {
    id: `${scope}.paymentMethodLabel`,
    defaultMessage: 'Payment method',
  },
  paymentMethodOther: {
    id: `${scope}.paymentMethodOther`,
    defaultMessage: 'Other',
  },
  paymentMethodOtherDescription: {
    id: `${scope}.paymentMethodOtherDescription`,
    defaultMessage: 'eg: Cash, Misc',
  },
  taxTypeDollar: {
    id: `${scope}.taxTypeDollar`,
    defaultMessage: '$',
  },
  taxTypePercent: {
    id: `${scope}.taxTypePercent`,
    defaultMessage: '%',
  },
  accountRequired: {
    id: `${scope}.accountRequired`,
    defaultMessage: 'Account code is required',
  },
  currencyRequired: {
    id: `${scope}.currencyRequired`,
    defaultMessage: 'Currency is required',
  },
  paymentTypeRequired: {
    id: `${scope}.paymentTypeRequired`,
    defaultMessage: 'Payment method is required',
  },
  hoursLabel: {
    id: `${scope}.hoursLabel`,
    defaultMessage: 'Hours',
  },
})
